export default {"src":"/_next/static/media/PD.8ae1e365.svg","height":18,"width":18};